// Kabinet paroli — xsib-core `selfcare` moduli bilan haqiqiy kontrakt.
// Manba: `selfcare/internal/AdminCredentialController.java`.
//
// ⚠️ BU RADIUS PAROLI EMAS. `subscriber.subscriber.password` (RADIUS/PPPoE
// autentifikatsiyasi, `features/subscriber/subscriberApi.ts` dagi
// `changePassword`) va kabinet paroli (mijozning shaxsiy kabinetiga kirish
// paroli) IKKI MUSTAQIL maydon, ikki mustaqil endpoint. Ularni aralashtirish
// operatorni "parolni almashtirdim, lekin internet ishlamay qoldi" (yoki
// aksincha) degan holatga olib keladi.
//
// Huquq YANGI emas, `subscriber.password.set` qayta ishlatiladi — backend
// javadoc'ida aytilganidek: bu klass ANIQ shu ishni qiladi ("abonent paroli
// o'rnatiladi, hech qachon ko'rsatilmaydi"), faqat boshqa parol maydoniga.

import { z } from 'zod'
import { api } from '@/shared/api/client'
import { operationResultSchema, type OperationResult } from '@/shared/api/operationResult'

const passwordStatusSchema = z.object({
  set: z.boolean(),
  updatedAt: z.string().nullish(),
})

export interface SelfcarePasswordStatus {
  /** Kabinet paroli o'rnatilganmi */
  set: boolean
  /** Oxirgi marta qachon o'rnatilgani (ISO), yoki `null` */
  updatedAt: string | null
}

/**
 * Kabinet paroli o'rnatilganmi — panel tugmani shu asosda nomlaydi.
 *
 * ⚠️ Parolning O'ZI hech qachon qaytmaydi va qaytishi mumkin ham emas:
 * backend faqat xesh saqlaydi. Bu yerda kelayotgani — "bormi va qachon".
 */
export async function fetchSelfcarePasswordStatus(
  subscriberId: string,
): Promise<SelfcarePasswordStatus> {
  const response = await api.get<unknown>(
    `/api/selfcare-admin/subscribers/${subscriberId}/selfcare-password`,
  )
  const parsed = passwordStatusSchema.parse(response.data)
  return { set: parsed.set, updatedAt: parsed.updatedAt ?? null }
}

/**
 * Kabinet parolini xodim tomonidan o'rnatish.
 *
 * Abonent bu parolni HALI BILMAYDI — u yangi o'rnatiladi (vaucher/SMS OTP
 * infratuzilmasi hozircha yo'q). Abonent keyin o'zi kabinetdan almashtiradi.
 */
export async function setSelfcarePassword(
  subscriberId: string,
  password: string,
): Promise<OperationResult> {
  const response = await api.post<unknown>(
    `/api/selfcare-admin/subscribers/${subscriberId}/selfcare-password`,
    { password },
  )
  return operationResultSchema.parse(response.data)
}
